import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d686cb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "plist"
}
const _hoisted_2 = { class: "tops-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "[置顶]", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "date"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "iframe"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "article-content"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-left" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))

import articles, { State } from '@/store/articles/home';
import * as filters from '@/views/filters';
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Content from './Content.vue';
import { setting } from '@/config';
import { isMobile } from '@/common/download'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const data = computed<State>(() => store.state[articles.name])
const feeds = computed(() => {
    if (data.value.feedIndex == -1) {
        return data.value.feeds
    } else {
        return [data.value.feeds[data.value.feedIndex]]
    }
})
const tops = computed(() => data.value.tops)
const state = reactive({
    isMobile: false,
    height: 0,
    width: 0,
    goTopVisible: false,
})

const contentsStyle = computed(() => {
    if (!state.isMobile) {
        return { height: state.height + 'px' }
    }
})

onMounted(() => {
    state.isMobile = isMobile()
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onScroll)
    onResize()
    route.params.id ? data.value.feedsVisible = false : null

    if (isMobile() && setting.first && data.value.article) {
        // let url = "fuyintv://yuedu/article/" + data.value.article.itemid;
        // window.location.href = url
    }
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
    window.removeEventListener('scroll', onScroll)
})

function onSelected(item: { islink: number, linkurl: string, itemid: number, }) {
    router.push(`/articles/${item.itemid}/index.html`)
    data.value.feedsVisible = state.width > 1100
    console.info('--------------onselected')
}

function onResize() {
    state.width = window.innerWidth
    state.height = window.innerHeight - 60
}
function onGoTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
}
function onScroll() {
    state.goTopVisible = window.scrollY > 300
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["articles-page", _unref(data).feedsVisible ? 'double' : 'single'])
  }, [
    (!_unref(state).isMobile || _unref(data).feedsVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["articles-contents", _unref(state).isMobile ? 'phonel' : 'pcl']),
          style: _normalizeStyle(_unref(contentsStyle))
        }, [
          (_unref(data).feedsVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tops), (item) => {
                    return (_openBlock(), _createElementBlock("a", {
                      onClick: ($event: any) => (onSelected(item))
                    }, [
                      _hoisted_4,
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ], 8, _hoisted_3))
                  }), 256))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feeds), (current) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["p1", { big: current.list.length == 1 }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.list, (item, i) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "item",
                        onClick: ($event: any) => {onSelected(item);}
                      }, [
                        (i == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(filters).date(item.addtime)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                        _createElementVNode("div", {
                          class: "poster",
                          style: _normalizeStyle(_unref(filters).bg(item.thumb))
                        }, null, 4),
                        _hoisted_8
                      ], 8, _hoisted_5))
                    }), 256))
                  ], 2))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (!_unref(state).isMobile)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "turn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(data).feedsVisible = !_unref(data).feedsVisible))
              }, _hoisted_10))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true),
    (_unref(data).article && _unref(data).article.islink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createElementVNode("iframe", {
              src: _unref(data).article.linkurl
            }, null, 8, _hoisted_12)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (!_unref(data).feedsVisible)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "gobtn go-prev",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(data).feedsVisible = true))
              }, _hoisted_15))
            : _createCommentVNode("", true),
          (_unref(state).goTopVisible)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "gobtn go-top",
                onClick: onGoTop
              }, _hoisted_17))
            : _createCommentVNode("", true),
          _createVNode(Content, {
            article: _unref(data).article
          }, null, 8, ["article"])
        ])),
    _hoisted_18
  ], 2))
}
}

})